import { lazy } from 'react';

const Mail = {
  Helmet: lazy(() => import('./Helmet.tsx')),
  PromotionMail: lazy(() => import('./PromotionMail/index.ts')),
};

export default Mail;
export { PromotionMailSearchParams } from './PromotionMail/types.ts';
